import { createValueFormatter } from '@cmg/data-grid';

import type {
  CalendarGridColDef,
  CalendarGridRowData,
  CalendarGridValueGetterFunc,
} from '../../CalendarGrid.model';
import { IssuerCellRenderer } from './IssuerCellRenderer';

export type Value = string | null | undefined;

export const valueGetter: CalendarGridValueGetterFunc<Value> = ({ data }) => {
  return data?.issuer?.name ?? null;
};

export const valueFormatter = createValueFormatter<CalendarGridRowData, Value>({
  gridRow: ({ value }) => value ?? '-',
});

export const comparator = (issuerA: Value, issuerB: Value) => {
  const issuerAName = issuerA ?? '-';
  const issuerBName = issuerB ?? '-';

  return issuerAName.localeCompare(issuerBName);
};

const issuerColDef: CalendarGridColDef<Value> = {
  colId: 'issuer',
  headerName: 'Issuer',
  width: 273,
  type: 'text',
  pinned: 'left',
  lockVisible: true,
  lockPosition: 'left',
  filter: 'agTextColumnFilter',
  cellRenderer: IssuerCellRenderer,
  valueGetter,
  valueFormatter,
  comparator,
};

export default issuerColDef;
